"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteStrategyById = deleteStrategyById;
exports.getImagePrefix = getImagePrefix;
exports.getResPath = getResPath;
exports.getUpgradeDetail = getUpgradeDetail;
exports.insertStrategyNew = insertStrategyNew;
exports.updateStrategyOne = updateStrategyOne;
exports.uploadPhotoAddOrUpd = uploadPhotoAddOrUpd;
exports.uploadStrategyPhoto = uploadStrategyPhoto;
exports.xyUpgradeStrategySelPage = xyUpgradeStrategySelPage;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
/**
 * 获取图片资源前缀
 * @returns {Promise}
 */
function getImagePrefix() {
  return (0, _requestAuth.default)({
    url: '/xyUpgradeStrategy/getResPath',
    method: 'get'
  });
}
function getResPath() {
  return (0, _requestAuth.default)({
    url: '/xyUpgradeStrategy/getResPath',
    method: 'get'
  });
}
function xyUpgradeStrategySelPage(query) {
  return (0, _requestAuth.default)({
    url: '/xyUpgradeStrategy/page',
    method: 'get',
    params: query
  });
}

// 添加新攻略
function insertStrategyNew(data) {
  return (0, _requestAuth.default)({
    url: '/xyUpgradeStrategy/insert',
    method: 'post',
    data: data
  });
}

// 编辑攻略
function updateStrategyOne(data) {
  return (0, _requestAuth.default)({
    url: '/xyUpgradeStrategy/basicUpdate',
    method: 'put',
    data: data
  });
}

// 删除攻略信息
function deleteStrategyById(id) {
  return (0, _requestAuth.default)({
    url: '/xyUpgradeStrategy?id=' + id,
    method: 'delete'
  });
}

// 通过id攻略信息
function getUpgradeDetail(id) {
  return (0, _requestAuth.default)({
    url: '/xyUpgradeStrategy/detail/' + id,
    method: 'get'
  });
}

// 上传图片-按钮
function uploadStrategyPhoto(params) {
  return (0, _requestAuth.default)({
    url: '/xyUpgradeStrategy/uploadStrategyPhoto',
    method: 'post',
    data: params
  });
}

// 上传图片返回路径（用于新建，编辑）
function uploadPhotoAddOrUpd(params) {
  return (0, _requestAuth.default)({
    url: '/xyUpgradeStrategy/uploadPhotoAddOrUpd',
    method: 'post',
    data: params
  });
}

//  获取文件上传前缀路径
// export function getResPath(path) {
//   return request({
//     url: '/xyUpgradeStrategy/getResPath',
//     method: 'get',
//     params: { path }
//   })
// }
//}